<template>
    <li class="nav-item dropdown ">
        <a class="nav-link" @click="cargardatos()" data-toggle="dropdown" href="#">
            <i class="fa fa-envelope"></i>
            <span style="margin-left: 5px;" class="badge badge-danger bg-blue">{{numero_correos}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" style="height: auto; overflow-x: hidden; min-width: 250px;">
            <ListaCorreos :correos="correos" />
        </div>
    </li>
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import ListaCorreos from './CorreosLista.vue';


export default({
    components:{
        ListaCorreos
    },
    data() {
        return {
            correos: [],
            numero_correos: '0',
        }
    },
    methods: {
        async cargardatos() {
            /* get  modulos/pwgsapi/index.php/correos/publicos */
            const api = new PwgsApi;
            let totalcorreos = 0;
            const datos = await api.get('correos/publicos');
    if (datos.datos) {
  this.correos = [...datos.datos].sort((a, b) => {
    const nombreA = a.nombre_correo.toLowerCase().trim();
    const nombreB = b.nombre_correo.toLowerCase().trim();

    if (nombreA === "mi correo") return -1;
    if (nombreB === "mi correo") return 1;
    return nombreA.localeCompare(nombreB);
  });
}
     
                for (let i = 0; i < this.correos.length; i++) { 
                if(this.correos[i].correo_usuario=='1') totalcorreos += parseInt(this.correos[i].n_nuevos)
            }
            this.numero_correos = totalcorreos;                
        },       

    },
    mounted() {
        this.cargardatos();
    }
})
</script>
